class ProductMembershipOffer extends HTMLElement {
  constructor() {
    super();
    this.addToCartButton = this.querySelector('.purchase-option__add-to-cart-button');
    this.product = this.dataset.productHandle;
    this.variantId = this.dataset.variantId;
    this.sellingPlanId = this.dataset.sellingPlanId;
    this.discountCode = this.dataset.discountCode;

    this.addToCartButton.addEventListener('click', () => {
      this.addToCart();
    });
  }

  async addToCart() {
    this.addToCartButton.setAttribute('disabled', 'disabled');
    this.addToCartButton.classList.add('loading');
    this.addToCartButton.querySelector('.loading__spinner').classList.remove('hidden');

    try {
      await new SubscriptionCart().checkout(
        {
          mainProduct: {
            handle: this.product,
            variantId: this.variantId,
            sellingPlanId: this.sellingPlanId,
          },
          email: null,
          discountCode: this.discountCode,
        },
        false
      );
    } catch (error) {
      console.error('Error adding subscription to cart:', error);
    } finally {
      this.addToCartButton.classList.remove('loading');
      this.addToCartButton.querySelector('.loading__spinner').classList.add('hidden');
      this.addToCartButton.removeAttribute('disabled');
    }
  }
}

if (!customElements.get('product-membership-offer')) {
  customElements.define('product-membership-offer', ProductMembershipOffer);
}
